import { Typography } from 'antd'
import { NoImageDiv } from 'components/shared/NoImageDiv'
import { useClassifications } from 'hooks/static'
import { getClassificationName } from 'libs/getClassificationName'
import Image from 'next/future/image'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { VFC } from 'react'

type Props = {
  xs?: boolean
}
export const ArtWorkFeatures: VFC<Props> = ({ xs }) => {
  const { data: classifications } = useClassifications()
  const router = useRouter()
  const { i18n } = useTranslation()

  return (
    <div
      style={{
        padding: xs ? '24px 0 60px 0' : '40px 0px 80px 0px',
        display: 'flex',
        flexDirection: 'row',
        gap: xs ? '16px' : '28px',
        flexWrap: xs ? 'wrap' : 'nowrap',
      }}
    >
      {classifications &&
        classifications.slice(0, 6).map((classification) => (
          <div
            key={classification.id}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              width: 'calc(50% - 8px)',
              maxWidth: '170px',
              cursor: 'pointer',
            }}
            onClick={() =>
              router.push(
                {
                  pathname: '/art_works',
                  query: { art_work_classification_id_in: classification.id },
                },
                undefined,
                { shallow: true },
              )
            }
          >
            {classification.main_image_url ? (
              <Image
                src={classification.main_image_url}
                style={{
                  height: '102px',
                  objectFit: 'cover',
                  backgroundColor: '#ECECEC',
                }}
                alt={classification.name}
              />
            ) : (
              <NoImageDiv type="artwork" />
            )}
            <Typography.Text>
              {getClassificationName(classification, i18n.language)}
            </Typography.Text>
          </div>
        ))}
    </div>
  )
}
